import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAuthRequest } from '../interfaces/auth-request.interface';
import { IAuthResponse } from '../interfaces/auth-response.interface';

const OPTIONS = {
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
  }
};
const API_URL = environment.apiUrl;

@Injectable()
export class AuthHttp {

  constructor(private http: HttpClient) {}

  auth(body: IAuthRequest): Observable<IAuthResponse> {
    return this.http.post<IAuthResponse>(API_URL + 'v1/oauth/token', body, OPTIONS);
  }

  logout(): Observable<object> {
    return this.http.post(API_URL + 'v1/logout', {}, {});
  }
}
